import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { selectFinancialYearsListItems } from "../../../../../../redux/fms/financial-years/selector";
import { financialYears } from "../../../../../../redux/fms/financial-years/action";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementFinancialYears = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const financialYearsListData = useSelector(selectFinancialYearsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'BookBeginDate', headerName: 'Book Begin On', isDateValueFormat: true, searchField: 'BookBeginDate', sortable: true, filter: true, filterType: 'date', },
      { field: 'FinYearStartDate', headerName: 'FinYear Start On', isDateValueFormat: true },
      { field: 'FinYearEndDate', headerName: 'FinYear End On', isDateValueFormat: true },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(financialYears.delete({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years/delete`,
      entity: 'financialYears',
      jsonData:
      {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchFinancialYearsList();
    });
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Financial Year</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Financial Year',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const fetchFinancialYearsList = () => {
    dispatch(financialYears.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years/list`,
      entity: 'financialYears',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "CreatedOnUtc",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchFinancialYearsList()
  }, [pageData, pageSize])

  const handleReloadData = () => {
    fetchFinancialYearsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(financialYears.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/financial-years/list`,
      entity: 'financialYears',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (item: any) => {

  }

  return (
    <>
      {financialYearsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} rowData={financialYearsListData?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize} paginationData={financialYearsListData?.result?.pagination}
          enableFilter={true} onSearch={handleSearch} onSelect={handleSelect}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
          headingName="Financial Years" />
      }
    </>
  );
};

export default ManagementFinancialYears;


